import Tooltip from "../../../../components/tooltip";
import SimulationPortfolio from "../SimulateProcurement/Generation/SimulationPPEConsole";
// import SimulationSummaryAnalysis from "./Generation/SimulationSummaryChart";
// import GenerationAnalysis from "./Generation/SimulationGeneration";
import SimulationHeader from "../utility/SimulationHeader";
import { useEffect, useState } from "react";
import { useOptimizerNavigation } from "../utility/useOptimizerNavigation";
import MainHeader from "../utility/DateSession";
import { ErrorPopup } from "../../../../components/ErrorHandling";
import BlockRangeSelector from "../../../../components/BlockRangeSelector/BlockRangeSelector";
import { Download } from "lucide-react";
// import {
//   OptimizerCurrentUpdateData,
//   OptimizerGnaProceed,
// } from "../../Utility/RestApi";
import DateRangeSelector from "../DateRange/DateRangeSelector";
import { SearchBox } from "../../../../components/Search";
import { useSelector } from "react-redux";
import { start } from "repl";
import Loading from "../../../../components/Loading";
import SurplusDeficitForm from "./PowerSimulation";
export default function PowerIndex() {
  const { navigateToPage } = useOptimizerNavigation();
  const [error, setError] = useState<string | null>(null);
  const [open, setOpen] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedBlock, setSelectedBlock] = useState<any[]>([]);
  const [uniqueTargetDate, setUniqueTargetDate] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const preSelectedstartDate = useSelector(
    (state: any) => state.OptimizerDemoDate.startDate,
  );
  const preSelectedendDate = useSelector(
    (state: any) => state.OptimizerDemoDate.endDate,
  );
  const [selectedTargetDate, setSelectedTargetDate] = useState<
    Array<{ value: string; label: string; isFixed: boolean }>
  >([]);
  const handleDateChange = (
    start: Date | null,
    end: Date | null,
    allDates: Array<{ value: string; label: string; isFixed: boolean }>,
  ) => {
    setSelectedTargetDate(allDates);
  };
  return (
    <>
      <div className="w-full">
        {loading && <Loading />}
        <MainHeader />
        <div className="h-[calc(-85px+100vh)] p-4">
          <div className="w-full h-full flex flex-col gap-2">
            <SimulationHeader
              title="Portfolio Builder"
              tabsShow={false}
              refreshKey={refreshKey}
              setRefreshKey={setRefreshKey}
            />
            <div className=" flex flex-row gap-4 relative">
              <div
                className="gas-chart-container !p-0 bg-white shadow-[rgba(149,157,165,0.2)_0px_8px_24px] rounded-2xl"
                style={{
                  height: "calc(-195px + 100vh)",
                  width: "100%",
                }}
              >
                <div className="load-data grid grid-cols-1 p-0 md:grid-cols-1 grid-rows-full md:grid-rows-1 gap-2 h-full w-full md:overflow-hidden rounded-2xl bg-[#F5F7FA]">
                  <SurplusDeficitForm
                    refreshKey={refreshKey}
                    setRefreshKey={setRefreshKey}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <ErrorPopup error={error} onClose={() => setError(null)} />
        <div className="gna-footer-container">
          <div className="grid grid-cols-3 justify-between gap-5 ">
            <Tooltip
              note={
                <p>
                  {/* Default values and variable charges are auto-fetched from
                  system. */}
                </p>
              }
              text=""
            >
              <p className="gna-footer-text">Source</p>
            </Tooltip>
            <p className="gna-footer-text col-span-1 text-center">
              Powered by <strong>GNA Energy</strong>
            </p>
            <strong className="gna-footer-text col-span-1 text-end">
              Beta Version
            </strong>
          </div>
        </div>
      </div>
    </>
  );
}
